import { Error } from "..";
import Monster from "../../assets/images/monster-red.png";

const NotFound = () => <Error img={Monster} title="Página no encontrada" />;

export default NotFound;
